import type { LinhaConta } from '../types';

interface CaixaContaProps {
  titulo: string;
  linhas: LinhaConta[];
}

export default function CaixaConta({ titulo, linhas }: CaixaContaProps) {
  if (!linhas || linhas.length === 0) return null;

  return (
    <div className="rounded-lg border border-[#DADCE0] p-4">
      <p className="text-xs font-medium uppercase tracking-wide text-[#5F6368]">{titulo}</p>
      <div className="mt-3 space-y-2">
        {linhas.map((linha, indice) => (
          <div key={`${linha.linha}-${indice}`}>
            {linha.destaque && <div className="my-2 border-t border-[#DADCE0]" />}
            <div className="flex items-center justify-between">
              <span
                className={`text-sm text-[#5F6368] ${linha.destaque ? 'font-bold' : ''}`}
              >
                {linha.linha}
              </span>
              <span
                className={`text-sm ${linha.destaque ? 'font-bold text-foreground-950' : 'text-foreground-900'}`}
              >
                {linha.valor}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}